import * as Yup from "yup";

const convenioValidator = Yup.object().shape({
  numero: Yup.string().required("Número do Convênio"),
  descricao: Yup.string().required("Descrição"),
  carteira: Yup.string().required("Carteira"),
  variacaoCarteira: Yup.string().required("Variação da Carteira"),
  padraoCnab: Yup.string().required("Padrão CNAB"),
  nossoNumeroInicial: Yup.string().required("Nosso Número Inicial"),
  numeroRemessaInicial: Yup.string().required("Número da remessa inicial"),
  instrucoes: Yup.string().required("Campo Instruções"),
});

export default convenioValidator;
